// Bed geometry (PLR-10). PURE: a bed is two blocks — a `foot` at the placed cell
// and a `head` one block along `facing`. These helpers place, locate the partner
// half, and derive facing from the player's yaw, shared by the host and tests.

export type Facing = 'north' | 'east' | 'south' | 'west';

/** Horizontal (dx,dz) offset from the foot toward the head, per facing. */
export const BED_FACING_OFFSET: Record<Facing, readonly [number, number]> = {
  north: [0, -1],
  south: [0, 1],
  east: [1, 0],
  west: [-1, 0],
};

/** Cardinal the player faces, from yaw (yaw 0 looks toward −z = north). */
export function facingFromYaw(yaw: number): Facing {
  const dx = -Math.sin(yaw), dz = -Math.cos(yaw);
  return Math.abs(dx) > Math.abs(dz) ? (dx > 0 ? 'east' : 'west') : (dz > 0 ? 'south' : 'north');
}

/** Offset from a bed half to its partner: foot→head is +facing, head→foot is −. */
export function partnerOffset(facing: Facing, part: 'foot' | 'head'): readonly [number, number] {
  const [ox, oz] = BED_FACING_OFFSET[facing];
  return part === 'foot' ? [ox, oz] : [-ox, -oz];
}
